import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { defineMessages, injectIntl } from 'react-intl';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { withAccount } from '../../../components/AccountContext';
import NewSurveyProject from './NewSurveyProjectComponent';
import { growlErrors, growlActionSuccess } from '../../../utils/NotificationUtil';
import { createSurveyProject } from '../../../services/apps/SurveyProjectService';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape, historyShape, intlShape } from '../../../components/prop-types';
import { validationMessages } from '../../../i18n/common';

const buildValidationSchema = formatMessage => (
  Yup.object().shape({
    projectName: Yup.string()
      .required(formatMessage(validationMessages.required)),
    surveyTemplateId: Yup.string()
      .required(formatMessage(validationMessages.required)),
  })
);

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

class NewSurveyProjectFormContainer extends Component {
  constructor() {
    super();
    this.onCancel = this.onCancel.bind(this);
    this.saveSurveyProject = this.saveSurveyProject.bind(this);
  }

  onCancel() {
    const { history, currentAccount } = this.props;
    history.push(`/accounts/${currentAccount}/survey-projects`);
  }

  async saveSurveyProject(formValues) {
    const {
      growl, history, currentAccount, intl,
    } = this.props;
    const { formatMessage } = intl;

    const { projectName: name, surveyTemplateId } = formValues;
    try {
      const newProject = await createSurveyProject({
        name,
        surveyTemplateId,
        accountId: currentAccount,
      });

      growlActionSuccess(growl, formatMessage(messages.successNoti));
      const newProjectId = newProject.createSurveyProject.id;
      const redirectURL = `/accounts/${currentAccount}/survey-projects/${newProjectId}`;
      history.push(redirectURL);
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  render() {
    const { templates: rawTemplates, intl: { formatMessage } } = this.props;


    const templates = rawTemplates.map(survey => ({
      value: survey.id,
      label: survey.title,
    }));
    const initialValues = {
      projectName: '',
      surveyTemplateId: '',
    };

    const validationSchema = buildValidationSchema(formatMessage);
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={async (values, formikBag) => {
                const { resetForm } = formikBag;
                await this.saveSurveyProject(values);
                resetForm();
              }}
              render={
                formProps => (
                  <NewSurveyProject
                    formProps={formProps}
                    onCancel={this.onCancel}
                    templates={templates}
                  />
                )
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

NewSurveyProjectFormContainer.propTypes = {
  growl: growlShape.isRequired,
  history: historyShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  templates: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default withGrowl(
  withAccount(
    withRouter(
      injectIntl(NewSurveyProjectFormContainer),
    ),
  ),
);
